exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./cdiv/en-US/js/cdiv-page/cdiv-page.css
// module id = 16
// module chunks = 14